@if (customPolicyInfo$ | async; as customPolicyInfo) {
	@if (customPolicyInfo.header) {
		<span class="h3">{{ customPolicyInfo.header }}</span>
	}
	@for (text of customPolicyInfo.text; track $index) {
		<p>{{ text }}</p>
	}
	@if (customPolicyInfo.link && (customPolicyInfo.link | allowedProtocolsCheck | async)) {
		<a [href]="customPolicyInfo.link" target="_blank" rel="noopener noreferrer">{{
			customPolicyInfo.linkName ?? customPolicyInfo.link
		}}</a>
	}
}
